export const setProducts = (payload) => {
    return {
        type:"SET_PRODUCTS",
        payload
    }
}